import { elementConstants } from "../../constants/cms/form/element/element.constants";
import { defaultContainerElement, defaultContentElement, defaultQuestionElement, defaultFieldElement, defaultEventElement } from "../models/defaultElements";
import { deepClone } from "../../helpers/objectHelper";


export const elementOrgin = (type) => {
    switch (type) {
        case elementConstants.FIELD:
            return deepClone(defaultFieldElement.data)
        case elementConstants.EVENT:
            return deepClone(defaultEventElement.data)
        case elementConstants.QUESTION:
            return deepClone(defaultQuestionElement.data)
        case elementConstants.CONTENT:
            return deepClone(defaultContentElement.data)
        case elementConstants.CONTAINER:
            return deepClone(defaultContainerElement.data)
        default:
            return null
    }
}